<template>
    <div>
        <div class="tool-data-row" v-if="legendsCount">
            <div class="tool-data-row" v-if="isPastTest">
                <div class="tool-data-col">
                    <div class="number-blk bg-green">{{legendsCount.correct}}</div>
                    <div class="text-blk">Correct</div>
                </div>
                <div class="tool-data-col"></div>
                <div class="tool-data-col">
                    <div class="number-blk bg-red">{{legendsCount.incorrect}}</div>
                    <div class="text-blk">Incorrect</div>
                </div>
                <div class="tool-data-col"></div>
                <div class="tool-data-col">
                    <div class="number-blk grey">{{legendsCount.notAttempted}}</div>
                    <div class="text-blk">Not Attempted</div>
                </div>
                <div class="tool-data-col"></div>
                <div class="tool-data-col">
                    <div class="number-blk blue">{{legendsCount.partiallyCorrect}}</div>
                    <div class="text-blk">Partially Correct</div>
                </div>
            </div>
            <div class="tool-data-row" v-else-if="isPreview">
				 <div class="tool-data-col">
					<div class="number-blk bg-green">{{legendsCount.easy}}</div>
					<div class="text-blk">Easy</div>
				</div>
				
				<div class="tool-data-col">
					<div class="number-blk bg-yellow">{{legendsCount.moderate}}</div>
					<div class="text-blk">Moderate</div>
				</div>
				<div class="tool-data-col">
					<div class="number-blk bg-red">{{legendsCount.tough}}</div>
					<div class="text-blk">Tough</div>
				</div>
    	</div>
            <div class="tool-data-row" v-else>

					<div class="tool-data-col">
						<div class="number-blk bg-green">{{legendsCount.answered}}</div>
						<div class="text-blk">Answered</div>
					</div>
					<div class="tool-data-col">
						<div class="number-blk bg-gray">{{legendsCount.notVisited}}</div>
						<div class="text-blk">Not Visited</div>
					</div>
					<div class="tool-data-col">
						<div class="number-blk bg-red">{{legendsCount.notAnswered}}</div>
						<div class="text-blk">Not Answered</div>
					</div>
					<div class="tool-data-col">
						<div class="number-blk bg-yellow">{{legendsCount.reviewLater}}</div>
						<div class="text-blk">Review Later</div>
					</div>
					<div class="tool-data-col tool-data-col-100">
						<div class="number-blk bg-green">
							{{legendsCount.answeredReviewLater}}
							<span class="yel-doth"></span>
						</div>
						<div class="text-blk">
							Answered & Marked for Review
							<div class="red-txt">(Will be considered for evaluation)</div>
						</div>
					</div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    name: "LegendsPreview",
    props: ["legendsCount","isPreview"],
    computed: {
        ...mapGetters("testStore", ["isPastTest"])
    }
};
</script>